import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="px-3">
        <div>
          <div>
            <p className="text-lg font-medium  tracking-wider">
              Privacy Policy
            </p>
            <div className="flex border-solid border-inputFieldGrey rounded-sm items-center p-2 lg:col-span-2 lg:px-5">
              <p className="text-var(--background, #19161B) font-Satoshi text-base font-light leading-6 tracking-tight">
                We are committed to protecting your privacy. This privacy policy
                explains how we collect, use, and disclose your personal
                information. By using our services, you consent to the
                collection and use of your personal information as described in
                this policy.
                <p />
                <p>
                  1. Information We Collect We may collect personal information
                  such as your name, email address, and contact information when
                  you interact with our website or use our services. We may also
                  collect non-personal information such as your IP address,
                  browser type, and device information.
                </p>
                <p>
                  {" "}
                  2. How We Use Your Information We may use your personal
                  information to provide and improve our services, communicate
                  with you, and personalize your experience. We may also use
                  your information for marketing purposes, but only with your
                  consent.
                </p>
                <p>
                  3. Information Sharing We do not sell, trade, or transfer your
                  personal information to third parties without your consent.
                  However, we may share your information with trusted
                  third-party service providers who assist us in operating our
                  website and providing our services.
                </p>{" "}
                <p>
                  {" "}
                  4. Data Security We take reasonable measures to protect your
                  personal information from unauthorized access, disclosure,
                  alteration, and destruction. However, no method of
                  transmission over the internet or electronic storage is 100%
                  secure, and we cannot guarantee absolute security.
                </p>{" "}
                <p>
                  5. Cookies and Tracking Technologies We may use cookies and
                  similar tracking technologies to collect information about
                  your browsing behavior and preferences. You can choose to
                  disable cookies through your browser settings, but this may
                  affect your ability to use certain features of our website.
                </p>{" "}
                <p>
                  6. Links to Third-Party Websites Our website may contain links
                  to third-party websites. We are not responsible for the
                  privacy practices or content of these websites. We encourage
                  you to review the privacy policies of these websites before
                  providing any personal information.
                </p>{" "}
                <p>
                  7. Children's Privacy Our services are not intended for
                  children under the age of 13. We do not knowingly collect
                  personal information from children under the age of 13. If you
                  believe that we have collected personal information from a
                  child under the age of 13, please contact us immediately.
                </p>{" "}
                <p>
                  8. Changes to this Privacy Policy We may update this privacy
                  policy from time to time. Any changes will be posted on this
                  page, and the revised policy will be effective immediately
                  upon posting.
                </p>{" "}
                <p>
                  9. Contact Us If you have any questions or concerns about our
                  privacy policy, please contact us at <a>support@yupup.com</a>{" "}
                  or 415-788-3300.
                </p>
              </p>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
